import {
  updatesCtrl
} from '../admin/modals';
import {
  TerminalCommandModal
} from '../admin/terminal-command-modal.component';
import {
  DebugInfoModal
} from '../admin/debug-info-modal.component';
import ExcellentExport from 'excellentexport';
import {
  DEFAULT_STAT_LIMIT
} from '../common/config';

require('./header.component.scss');

class HeaderController {
  constructor(
    $scope,
    $element,
    $window,
    $timeout,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    $cookies,
    $modal,
    FilterEditorService,
    $http,
    CurrentFilterDataService,
    $q,
    FiltersService,
    LocalStorageService,
    FieldsModalService,
    LayoutService,
    ErrorHandlerService,
    AggregateDataService,
    TreeService,
    $templateCache,
    AdminModalService,
    SpecialModalService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.LayoutService = LayoutService;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.AdminModalService = AdminModalService;
    this.AggregateDataService = AggregateDataService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.langClasses = {
      'ru': 'flag-icon-ru',
      'en': 'flag-icon-gb',
      'cn': 'flag-icon-cn',
    };
    this.selectedLang = $cookies.get('django_language') || PermissionService.selectedLang || PermissionService.defaultLang;
    this.$modal = $modal;
    this.$cookies = $cookies;
    this.FilterEditorService = FilterEditorService;
    this.$http = $http;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.$q = $q;
    this.FiltersService = FiltersService;
    this.CurrentFilterService = CurrentFilterService;
    this.localStorage = LocalStorageService;
    this.FieldsModalService = FieldsModalService;
    this.TreeService = TreeService;
    this.lensePanel = this.$element.find('.lens-panel')[0];
    this.$isShowPanelWords = true;
    this.userNameWaxWidth = 'unset';
    this.$templateCache = $templateCache;
    this.SpecialModalService = SpecialModalService;


    this.$scope.$watch('$ctrl.filter.isChanged', () =>
      this.$timeout(() => this.setUserNameWaxWidth(), 10)
    );

    // this.menuSearch = {
    //   '/admin/agent/agent/': this.localStorage.getItem('/admin/agent/agent/', ''),
    //   '/admin/agent/attachedfile/': this.localStorage.getItem('/admin/agent/attachedfile/', ''),
    //   '/admin/auth/user/': this.localStorage.getItem('/admin/auth/user/', ''),
    //   '/admin/agent/device/': this.localStorage.getItem('/admin/agent/device/', ''),
    //   '/admin/agent/account/': this.localStorage.getItem('/admin/agent/account/', ''),
    //   '/admin/agent/application/': this.localStorage.getItem('/admin/agent/application/', ''),
    //   '/admin/agent/config/': this.localStorage.getItem('/admin/agent/config/', ''),
    // };

    this.$scope.$on('factsLoaded', () => {
      if (this.filter.toExcel && this.filter.toExcel.convertToExel) {
        const table = document.getElementById('datatable');
        table.innerHTML = table.innerHTML.replace(/<img[^>]+>(<\/img>)?|filter="filter"/g, '');
        const el = document.getElementById('ExcelDownloadItem');
        ExcellentExport.excel(el, 'datatable');
        el.click();
        this.filter.customLimit = this.filter.toExcel.normalLimit;
        delete this.filter.toExcel;
        this.$rootScope.$broadcast('reload');
      }
    });

    this.$rootScope.$on('splitter1Changed', (e, d, d2, name) => {
      this.moveTab();
      this.setUserNameWaxWidth();
    });

    this.$scope.$on('init', e => {
      this.updateMenu();
      this.setUserNameWaxWidth();
    });

    // const uAgent = this.$window.navigator.userAgent;
    // if (!!uAgent.match(/Trident.*rv\:11\./) || !!uAgent.match(/MSIE/)) {
    //   ErrorHandlerService.showErrorMessageBox(
    //     gettext('Ошибка браузера'),
    //     gettext('Ваша версия браузера не поддерживается. Используйте браузеры Chrome, Firefox или Edge'),
    //     null, true
    //   );
    // }
  }

  updateMenu() {
    const aList = this.$window.document.querySelectorAll('.sorted-menu-item');
    aList.forEach(a => a.search = this.localStorage.getItem(a.pathname, ''));
  }

  htmlReport() {
    this.currentFilter.filter.url = '/analytics/report/facts/';
    if (this.currentFilter.filter.order === 'record_count') {
      this.currentFilter.filter.order = 'local_time';
    }
    this.router.openNewWindow('&limit=1000000000');
  }

  link() {
    alert(this.$templateCache.get('panel_menu.html'));
  }

  get isUserNameWaxWidth() {
    return this.userNameWaxWidth > 25;
  }

  setUserNameWaxWidth() {
    if (!this.adminMenuWidth) {
      this.adminMenuWidth = this.$element.find('.admin-menu').width() -
        (this.$element.find('.lense-admin-width') ? this.$element.find('.lense-admin-width').width() : 0);
    }

    if (this.$isShowPanelWords) {
      let w = 0;
      this.$element.find('.lense-width').each(function() {
        w += this.offsetWidth;
      });
      this.lenseWidth = w;
    }
    const d = 12;
    const spaceWidth = this.lensePanel.offsetWidth - this.lenseWidth - this.adminMenuWidth;
    this.$isShowPanelWords = spaceWidth > d;
    if (this.$isShowPanelWords) {
      this.userNameWaxWidth = (spaceWidth - d);
    }
  }

  get adminTitle() {
    return gettext('Меню') + (this.permission.userName ? ` (${
      this.permission.userName[0].toUpperCase()}${this.permission.userName.substring(1)})` : '');
  }

  get isShowPanelWords() {
    return this.$isShowPanelWords;
  }

  openOptions() {
    this.LayoutService.openOptions();
  }

  get isCardOrDashboard() {
    return this.filter.isDashboard || this.filter.isCard;
  }

  nop(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  openNewDataWindow() {
    this.FieldsModalService.open('CSV');
    // this.router.openNewWindow(`&limit=${this.filter.customLimit ? this.filter.customLimit : 1000000000}`);
  }

  moveTab() {
    let left = $('sc-view').offset().left;
    const winWidth = $(window).width();
    // const max_left = winWidth < 1495 ? 300 : 300;
    const max_left = 520;
    if (left < max_left) left = max_left;
    $('.lens-panel').css({
      'left': left
    });
    // this.$timeout(() => {
    const showScreenPanel = $('.show-screen-panel');
    showScreenPanel.css({
      'right': winWidth - left + 60
    });
    // }, 500);


    if ($('sc-view').width() < 1100)
      $('.lens-panel .hideable').hide();
    else
      $('.lens-panel .hideable').show();
  }

  openNewWindow() {
    this.router.openNewWindow();
    const urlArr = this.router.search().frameUrl.split('/');
    if (urlArr[0] === 'remote' || urlArr[1] === 'remote') {
      const frame = this.LayoutService.getMainFrame();
      if (frame) frame.src = 'about:blank';
    }
  }

  downloadZip() {
    const filterUrl = this.CurrentFilterService.filter.url;
    this.CurrentFilterService.filter.url = '/analytics/download/zip/';
    this.zipUrl = this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
    this.CurrentFilterService.filter.url = filterUrl;
    // console.log(this.router);
  }

  get isFilterChanged() {
    return this.currentFilter.filter ? this.currentFilter.filter.isChanged : false;
  }

  printContainer() {
    this.LayoutService.printContainer(this.CurrentFilterDataService.filterData.filterData);
  }

  saveAsPicture() {
    this.LayoutService.saveAsPicture(this.CurrentFilterDataService.filterData.filterData,
      message => {
        this.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка при получении изображения'), message, null, true);
      });
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  reset() {
    this.router.resetFilter();
  }

  debugInfo() {
    this.AdminModalService.debugInfo();
  }

  getLinkToPDF() {
    const timeFrom = this.CurrentFilterService.getTimeFrom();
    const timeTo = this.CurrentFilterService.getTimeTo();
    return this.filterBar.id ? `/analytics/filter/pdf?id=${this.filterBar.id}&time_from=${timeFrom}&time_to=${timeTo}` : '';
  }

  terminalCommand(terminalCommandValue, commandText) {
    this.AdminModalService.terminalCommand(terminalCommandValue, commandText);
  }

  saveFilter(asNew) {
    this.FilterEditorService.saveFilter(asNew);
  }

  editFilter() {
    if (this.CurrentFilterService.filter.isCardFilter) return;
    const filter = this.CurrentFilterService.filter.id &&
      this.CurrentFilterService.filter.isAnalyticPolitic ?
      this.FiltersService.findById(this.CurrentFilterService.filter.id) : this.CurrentFilterService.filter;
    this.FilterEditorService.editModal({
      filter: filter,
      asNew: false,
      selectFilter: true,
    });
  }

  updateServer() {
    this.$modal.open({
        templateUrl: 'updatesDialog.html',
        controller: updatesCtrl,
      })
      .result
      .then(result => {
        // console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  selectLang(lang) {
    if (lang !== this.$cookies.get('django_language')) {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 100);
      this.$cookies.put('django_language', lang, {
        expires: expires
      });
      location.reload();
    }
  }

  newFilter(type) {
    this.router.isEditDasboard = false;
    this.router.newFilter(type);
  }

  viewReport() {
    this.router.panel = 'catalog';
    this.$rootScope.$broadcast('resize');
  }

  getEventsLink() {
    const timeFrom = this.CurrentFilterService.getTimeFrom();
    const timeTo = this.CurrentFilterService.getTimeTo();
    return '/analytics/get_events?time_from=' + timeFrom + '&time_to=' + timeTo;
  }

  getEventsFileName() {
    return 'Events.zip';
  }

  get isDownloadToExcel() {
    if (!this.filter || !this.currentFilter) return false;
    return ((this.filter.mode === 'stat' ||
          (this.filter.isExplore && this.filter.listType === 'table' && this.permission.fact)) &&
        !this.currentFilter.frameUrl && this.filter.content_type == 'filter' &&
        !this.filter.isCardOrDashboard
      ) ||
      (this.filter.mode === 'reports' && this.hasGridId);
  }

  get hasGridId() {
    return this.filter.url === '/analytics/report/departure_time_report/' ||
      this.filter.url === '/analytics/report/departure_time_report_by_group/' ||
      this.filter.url === '/analytics/report/unproductive_time/' ||
      this.filter.url === '/analytics/report/latecomers/' ||
      this.filter.url === '/analytics/report/tabel/workinghours/' ||
      this.filter.url === '/analytics/report/tabel/activetime/' ||
      this.filter.url === '/analytics/report/tabel/torturernocount/' ||
      this.filter.url === '/analytics/report/tabel/printerusage/' ||
      this.filter.url === '/analytics/report/tabel/extended/' ||
      this.filter.url === '/analytics/report/summary/' ||
      this.filter.url === '/analytics/report/summary_by_group/' ||
      this.filter.url === '/analytics/report/aggregate/index/' ||
      this.filter.url === '/analytics/report/summary_statistic/' ||
      this.filter.url === '/analytics/report/product_time_report/' ||
      this.filter.url === '/analytics/report/facts/' ||
      this.filter.url === '/analytics/report/sites/' ||
      this.filter.url === '/analytics/inventory/devices/' ||
      this.filter.url === '/analytics/inventory/apps/' ||
      this.filter.url === '/analytics/report/anomaly/' ||
      this.filter.url === '/analytics/report/stat/' ||
      this.filter.url === '/analytics/report/stat/daily/' ||
      this.filter.url === '/analytics/report/aggregate/index/?lenta=false' ||
      this.filter.url === '/analytics/inventory/apps_report/' ||
      this.filter.url === '/analytics/report/downtime_report/';
  }

  download($event) {
    let table;
    let table_id = 'datatable';
    if (this.filter.mode === 'stat' || this.filter.mode === 'explore') {
      table = document.getElementById(table_id);
    } else {
      if (this.hasGridId) {
        table_id = 'grid';
      }
      const htmlTable = document.getElementById('iframe').contentDocument.getElementById(table_id);
      table = htmlTable ? this.createExcelTable(htmlTable) : null;
    }
    if (!table) return true;
    if (this.filter.mode === 'explore' && !(this.filter.toExcel && this.filter.toExcel.convertToExel)) {
      this.filter.toExcel = {
        normalLimit: this.filter.customLimit,
        convertToExel: true,
      };
      if (!this.filter.customLimit) this.filter.limit = 500; // DEFAULT_STAT_LIMIT;
      this.$rootScope.$broadcast('reload');
      return true;
    }
    this.LayoutService.download = true;
    // this.$scope.$apply();
    this.$timeout(() => {
      const a = document.createElement('a');
      a.download = 'Stats.xls';
      document.body.appendChild(a);
      ExcellentExport.excel(a, table);

      this.$timeout(() => {
        a.click();
        document.body.removeChild(a);
        this.LayoutService.download = false;
      }, 0);
      return true;
    }, 0);
    return true;
  }

  createExcelTable(table) {
    // drop hidden rows
    if (this.filter.url !== '/analytics/inventory/apps_report/') {
      $(table).find('tr:hidden').attr('excel', false);
    }
    const excelTable = table.cloneNode(true);
    if (excelTable.querySelector('.report-hours-hours')) {
      excelTable.querySelectorAll('.report-hours-hours').forEach(el => {
        el.remove();
      });
    }
    $(excelTable).find('[excel=false]').remove();
    return excelTable;
  }

  // "agent_account@user_name:user_name"
  getIsAgent(exect) {
    let AGENTDIM = 'agent_agent@';
    let USERDIM = 'agent_account@';
    let USERFULLDIM = 'agent_account@';
    if (exect) {
      AGENTDIM = 'agent_agent@computer_name:computer_name';
      USERDIM = 'agent_account@user_name:user_name';
      USERFULLDIM = 'agent_account@full_name:full_name';
    }
    const res = (
        this.filterBar.drilldown[0].indexOf(AGENTDIM) !== -1 ||
        this.filterBar.drilldown[0].indexOf(USERDIM) !== -1 ||
        this.filterBar.drilldown[0].indexOf(USERFULLDIM) !== -1
      ) && this.currentFilter.filter &&
      this.currentFilter.filter.filters &&
      this.currentFilter.filter.filters.some(f => (
        f.dimension.indexOf(AGENTDIM) !== -1 ||
        f.dimension.indexOf(USERDIM) !== -1 ||
        f.dimension.indexOf(USERFULLDIM) !== -1
      ));
    if (!res && !exect && this.currentFilter && this.currentFilter.lastScreenshots) {
      this.stopScreenView();
    }
    return res;
  }

  stopScreenView() {
    this.router.cleanRemoteUsers();
    window.CACHE.reset();
    this.$rootScope.$broadcast('reload');
  }

  connectRemoteUsers() {
    this.AggregateDataService.loadRemoteUsers().then(data => {
      this.AggregateDataService.allRemoteUsers = data;
      this.AggregateDataService.updateRemoteUsers();
      if (!this.AggregateDataService.remoteUsers || !this.AggregateDataService.remoteUsers.length) {
        this.ErrorHandlerService.showErrorMessageBox(
          gettext('Ошибка'),
          gettext('Не удалось установить связь c агентами'),
          null, true
        );
      } else this.router.setRemoteUsers();
    });
  }

  get isScreenViewSelected() {
    return this.router.isRemoteUsers || this.router.isLastScreenshots;
  }

  openTerminal() {
    this.SpecialModalService.openTerminal();
  }

}

export const HeaderComponent = {
  template: require('./header.component.html'),
  controller: HeaderController,
};



// WEBPACK FOOTER //
// ./src/layout/header.component.js